export const shellKeys = {
  "Skip to main content": "skip",
  "Maintenance mode enabled.": "maintenance",
  "Non-admin users are currently blocked.": "blocked",
  "Manage settings": "manageSettings",
  "Expand navigation": "expandNav",
  "Collapse navigation": "collapseNav",
  "Close navigation": "closeNav",
  "Open navigation": "openNav",
  "Main navigation": "mainNav",
  "Primary navigation": "primaryNav",
  "(opens in new tab)": "newTab",
  "Quick navigation": "quickNav",
  "Exit reorder": "exitReorder",
  "Reorder categories": "reorder",
  "Exit reorder mode": "exitReorderMode",
  "Unpin menu": "unpin",
  "Pin menu": "pin",
  "No applications installed yet": "noApps",
  "Category order saved": "orderSaved",
  "Failed to save category order": "orderFailed",
  "Category order reset to default": "orderReset",
  "Failed to reset category order": "resetFailed",
  "Drag categories to reorder": "dragCategories",
  "draggable category": "draggable",
  "{{category}} — position {{position}} of {{total}}": "position",
  "Reset to default order": "resetOrder",
  "Profile avatar": "profileAvatar",
  "User": "user",
  "Profile: {{name}}": "profileName",
  "Logout": "logout",
  "Theme": "theme",
  "Theme: {{theme}}": "themeName",
  "Light": "light",
  "Default": "defaultTheme",
  "Alerts": "alerts",
  "Unread notifications": "unreadNotifications",
  "Refresh": "refresh",
  "Mark all read": "markAll",
  "View Notification Center": "viewNotifications",
  "Search pages and media...": "searchMedia",
  "Search pages...": "searchPages",
  "Search dashboard pages and media": "searchMediaLabel",
  "Search dashboard pages": "searchPagesLabel",
  "Suggestions": "suggestions",
  "Results for “{{query}}”": "resultsFor",
  "Start typing to search pages...": "startTyping",
  "No results found for “{{query}}”": "noResultsFor",
  "Media": "media",
  "Searching media": "searchingMedia",
  "No media found": "noMedia",
  "No results found": "noResults",
  "navigate": "navigate",
  "open": "open",
  "close": "close",
  "Search": "search",
  "Close search": "closeSearch",
  "Loading notifications...": "loadingNotifications",
  "No notifications yet.": "emptyNotifications",
  "Could not load notifications.": "notificationError",
  "Unread notification": "unreadNotification",
  "Read": "read",
  "Unread": "unread",
  "Mark": "mark",
  "Mark read": "markRead",
  "Dismiss notification": "dismiss",
  "Retry": "retry",
  "Viewing the dashboard as {{name}}.": "impersonating",
  "Ending...": "ending",
  "Stop Impersonating": "stopImpersonation",
  "Failed to end impersonation": "endFailed",
  "Network error while ending impersonation": "endNetwork",
  "Demo mode active": "demoActive",
  "You’re viewing a live demo — changes reset every 30 minutes": "demoMessage",
  "Get QuickBox Pro": "getQuickBox"
} as const;
